export { default, getStaticProps } from 'src/pages/HallOfFame/pages/HallOfFameHome'
